export const EMOJI_LAYER_NAME = 'EmojiLayer';
